import { apiBeSession } from "./api";


export const leggiValori = async () => {
    return await apiBeSession.get('/leggiValori');
}
